<template>
<div class="mt-3 py-5">
	<b-container class="px-3 p-md-0">
		<b-row class="px-3 mb-5">
			<b-col md="5" sm="12" class="sign-up-top card m-auto p-0">
				<form @submit.prevent="login_exec">
					<div class="container mt-3">
						<div class="form-group m-auto p-3">
							<input id="email" type="email" placeholder="メールアドレス" v-model="loginForm.email" class="w-100" v-bind:class="{ error_input: loginForm.errors.email.length > 0 }">
							<div v-if="loginForm.errors.email.length > 0">
								<div class="error-text" v-for="(item, index) in loginForm.errors.email" :key="index">{{ item }}</div>
							</div>
						</div>
						<div class="form-group m-auto p-3 text-left">
							<input id="password" type="password" v-model="loginForm.password" class="w-100" placeholder="パスワード" v-bind:class="{ error_input: loginForm.errors.password.length > 0 }">
							<div v-if="loginForm.errors.password.length > 0">
								<div class="error-text" v-for="(item, index) in loginForm.errors.password" :key="index">{{ item }}</div>
							</div>
						</div>
					</div>
					<div class="text-center mx-4">
						<button id="login" type="submit" class="btn btn-success w-100 my-3">ログイン</button>
					</div>
					<div class="text-right mb-3 pr-3">
						<router-link to="/reminder">パスワードを忘れましたか？</router-link>
					</div>
				</form>
			</b-col>
		</b-row>
	</b-container>
</div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
	name: 'Top',
	components: {
	},
	data () {
		return {
			errors: [],
			isError: true,
			loginForm: {
				errors: {
					email: [],
					password: [],
				},
				email: "",
				password: "",
				remember: true,
			}
		}
	},
	// token == null || token == ''
	// token != null && token != ''
	// computed: {
	// 	...mapState('auth', ['token']),
	// 	token: function() {
	// 		return this.$store.getters["auth/token"];
	// 	}
	// },
	methods: {
		login_exec() {
			this.isError = false;
			this.loginForm.errors.email = [];
			this.loginForm.errors.password = [];
			if (!this.loginForm.email) {
				this.loginForm.errors.email.push('メールアドレスが入力されていません。');
				this.isError = true;
			} else {
				if (this.check_mail(this.loginForm.email)) {
					this.loginForm.errors.email.push('正しいメールアドレス を入力してください');
					this.isError = true;
				}	
			}
			if (!this.loginForm.password) {
				this.loginForm.errors.password.push('パスワードが入力されていません。');
				this.isError = true;
			}
			if (!this.isError) {
				this.login();
			} else {
				window.scrollTo({
					top: 0,
				});
			}
			return false;
	    },
		/*
		* login
		*/
	    async login() {
			if(this.loginForm.remember){
				localStorage.setItem("remember_email", this.loginForm.email);
			}
			this.$store.dispatch('auth/login', {
				email: this.loginForm.email,
				password: this.loginForm.password
			}).then(res => {}, error => {
				// バックエンドからエラーが返却された場合、ひとまずアラートでメッセージを出力
				console.log(error.response.data);
				if ('error' in error.response.data) {
					alert(error.response.data['error']);
					this.isError = true;
					window.scrollTo({
						top: 0,
					});
				}
			});
		},
		created() {
			if(localStorage.getItem("remember_email")!=null){
				this.loginForm.email = localStorage.getItem("remember_email");
			}
		}
	}
}
</script>

<style scoped>
.frame-head {
	border-bottom: 2px solid #EEF2F7;
}

.frame-head h3 {
	font-size: 24px;
}

.frame-footer {
	border-top: 2px solid #EEF2F7;
}

.note {
	font-size: 16px;
	color: #8E8E8E;
}

@media screen and (max-width: 575px) {
	/* .card {
		border: none;
	} */

	.frame-head {
    	border-bottom: none;
	}

	.frame-head h3 {
 	   	font-size: 20px;
	}

	.frame-footer {
		border-top: none;
	}
}
</style>


// WEBPACK FOOTER //
// src/components/Login.vue